import type { Theme } from '../../themes/themes';

export const createAccordionTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          paddingInline: theme.spacing(5),
          [theme.breakpoints.up('lg')]: {
            paddingInline: theme.spacing(6),
          },
          // Increased Specificity, so that line will be shown between accordion items.
          '&:not(:first-child).Mui-expanded.Mui-expanded.Mui-expanded:before /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */':
            { opacity: '1', display: 'block' },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          position: 'static',
          paddingInline: 0,
          paddingBlock: theme.spacing(5),
          [theme.breakpoints.up('lg')]: {
            paddingBlock: theme.spacing(8),
          },
          '& .MuiAccordionSummary-expandIconWrapper': {
            marginLeft: theme.spacing(6),
          },
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent',
            '&::before': {
              content: "''",
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              right: 0,
              zIndex: 1,
              border: `1px solid ${theme.palette.action.focus}`,
              pointerEvents: 'none',
            },
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: 0,
          paddingBottom: theme.spacing(5),
          [theme.breakpoints.up('lg')]: {
            paddingBottom: theme.spacing(8),
          },
        },
      },
    },
  },
});
